// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AutocompleteApiParameter, autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import { AutocompleteModel } from "@insite/client-framework/Types/ApiModels";

interface XngAutocompleteApiParameter extends AutocompleteApiParameter {
    signInPageUrl?: string;
}

type HandlerType = ApiHandler<XngAutocompleteApiParameter & HasOnSuccess<AutocompleteModel>, AutocompleteModel>;

export const XngRequestDataFromApi: HandlerType = async (props: any) => {
    try {
        if (props.apiParameter.searchOnTyping || props.apiParameter.query.length >= 3) {
            props.apiResult = await autocompleteSearch(props.apiParameter);
        }
    } catch (error: any) {
        if (error?.status === 403) {
            window.location.href = props.apiParameter.signInPageUrl;
        }
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);